<template>
  <div class="laypanel">
    <el-row class="querypanel">
      <el-col :span="12">
        <el-form ref="form"  label-width="120px" label-position="left">
          <el-form-item label="订单日期:">
            <el-date-picker
              v-model="byorderdate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="24">
        <div>
          <el-button style="margin-top: 10px; margin-left: 10px;" @click="querfzorder">查询订单</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row class="querypanel">
      <el-table
        stripe
        :data="qdorderdata"
        width="100%"
        ref="multipleTable">
        <el-table-column
          prop="countprice"
          width = "200px"
          label="销售总额">
        </el-table-column>
        <el-table-column
          prop="salecusname"
          label="渠道客户名称">
        </el-table-column>
        <el-table-column
          label="操作"
          width="80px"
        >
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="查看待分账金额" placement="top-start">
              <i class="fa fa-eye fa-lg ciicon curpointer" v-on:click="seeqdfz(scope.$index, qdorderdata)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-dialog :title="channelstate" :visible.sync="fzpanelvisible">
      <div class="showpcinfo">
        <el-form >
          <el-row class="querypanel">
            <el-col :span="12">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="客户名称:">
                  <el-input disabled v-model="qdcusname" ></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="所属渠道ID:" style="margin-left: 20px;">
                  <el-input disabled v-model="ownchannel" ></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="分润比率(%):">
                  <el-input disabled v-model="qdpersent" ></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="分账金额(元):" style="margin-left: 20px;">
                  <el-input v-model="fzprice" placeholder="金额可以微调"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <el-button style="margin-top: 20px" @click="savefzinfo">生成分账单</el-button>
          <el-button style="margin-top: 20px" @click="qrfk">确认付款</el-button>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
Vue.prototype.$http = axios
var that
export default {
  name: 'FxOrder',
  data () {
    return {
      byorderdate: '',
      qdorderdata: [],
      fzpanelvisible: false,
      qdcusname: '',
      ownchannel: '',
      qdpersent: '',
      fzprice: '',
      channelstate: '',
      fzorderid: ''
    }
  },
  mounted: function () {
    var v = getCookie('cusid')
    this.khid = v
    that = this
    if (that.khid === null) {
    }
  },
  methods: {
    querfzorder () {
      console.log('查找渠道客户，并列入数组')
      var qdkhlist = []
      var qstr1 = 'cusid = ' + this.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/control/ccquery',
        method: 'post',
        data: {
          whereinfo: {String: qstr1, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            if (res.data.data !== '[]') {
              var data = JSON.parse(res.data.data)
              for (var i = 0; i < data.length; i++) {
                qdkhlist.push(data[i].ccusid)
              }
              var qstr = 'sale_cus_id in (' + qdkhlist + ')'
              if (that.byorderdate !== null && that.byorderdate !== '') {
                qstr = qstr + " and op_time >= '" + that.byorderdate[0] + " 00:00:00' and op_time<='" + that.byorderdate[1] + " 23:59:59'"
              }
              that.$http({
                url: 'https://api.sqnetsoft.cn/order/gqdoi',
                method: 'post',
                data: {
                  whereinfo: {String: qstr, Valid: true},
                  groupinfo: {String: ' group by sale_cus_id', Valid: true}
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  if (res.data.success) {
                    console.log(JSON.parse(res.data.data))
                    that.qdorderdata = JSON.parse(res.data.data)
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            }
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    seeqdfz (index, data) {
      var qddata = data[index]
      console.log(qddata)
      var qstr = 'c_cusid = ' + qddata.salecusid
      that.$http({
        url: 'https://api.sqnetsoft.cn/control/gbcp',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            if (res.data.data !== '[]') {
              var qpercent = JSON.parse(res.data.data)
              that.fzpanelvisible = true
              that.qdcusname = qpercent[0].cusname.String
              that.ownchannel = qpercent[0].ccusid
              that.qdpersent = qpercent[0].channelpercent.String
              that.fzprice = qddata.countprice * (parseInt(qpercent[0].channelpercent.String) / 100)
            } else {
              that.fzprice = 0
            }
            console.log(JSON.parse(res.data.data))
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
      var qstr1 = 'channelid = ' + qddata.salecusid
      that.$http({
        url: 'https://api.sqnetsoft.cn/channel/gbcs',
        method: 'post',
        data: {
          whereinfo: {String: qstr1, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            if (res.data.data !== '[]') {
              console.log('渠道分账信息')
              var qddata = JSON.parse(res.data.data)
              console.log(qddata)
              that.fzorderid = qddata[0].id.Int64
              console.log(qddata[0].jsstate)
              if (qddata[0].jsstate === 0) {
                that.channelstate = '当前状态：已生成分账订单，未付款'
              } else {
                that.channelstate = '当前状态：分账订单已付款'
              }
              console.log(res.data.data)
            } else {
              that.fzorderid = 0
              that.channelstate = '当前状态：未生成分账订单，未付款'
            }
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    savefzinfo () {
      var idata = {
        channelid: parseInt(that.ownchannel),
        jsprice: that.fzprice.toString(),
        jsstate: parseInt(0),
        jsdate: '',
        cusid: parseInt(this.khid)
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/channel/abcs',
        method: 'post',
        data: idata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.fzpanelvisible = false
            that.$message({
              type: 'success',
              message: '分账单生成完毕!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    qrfk () {
      console.log('确认付款')
      if (that.fzorderid === 0) {
        that.$message({
          type: 'info',
          message: '请先生成分账订单!'
        })
      } else {
        var timestamp1 = Date.parse(new Date())
        var qstr = 'id = ' + that.fzorderid
        var upstr = 'jsstate = 1,jsdate=\'' + timestamp1 + '\''
        that.$http({
          url: 'https://api.sqnetsoft.cn/channel/ubcs',
          method: 'post',
          data: {
            whereinfo: {String: qstr, Valid: true},
            fieldparams: {String: upstr, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              that.fzpanelvisible = true
              if (res.data.data !== '[]') {
                that.$message({
                  type: 'success',
                  message: '分账状态已更新！'
                })
                that.fzpanelvisible = false
              }
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>



// WEBPACK FOOTER //
// src/components/finance/ChannelFZ.vue